export default {
    disclaimer: false,
    loading: false,
    calculatorModel: false,
    alert: {
        active: false,
        color: "",
        text: "",
        icon: ""
    },
    user: null,
    veterinaryColleges: [],
    isDrugsManagement: false,
    userSection: false,
    link_redirect: null,
    confirmModel: {
        active: false,
        text: "",
        action: "",
        confirmText: "",
        closeText: "",
        parameters: null
    },
    confirmOpenOnApp: false,
    hasDynamicLink: false,
    fromLogin: false,
    stepper: 1,
    stepperTotal: 1,
    stepperData: [],
    stepperModel: true,
    homeAdds: null,
    postActivity: null,
    emailConfirmation: false,
    trends: [
        {
            "name": "Tramadol",
            "category": "Medicamentos",
            "path": "/categories/1/drugs/tramadol"
        },
        {
            "name": "Ondansetrona",
            "category": "Medicamentos",
            "path": "/categories/1/drugs/ondansetrona"
        },
        {
            "name": "Dexametasona",
            "category": "Medicamentos",
            "path": "/categories/1/drugs/dexametasona"
        },
        {
            "name": "Metronidazol",
            "category": "Medicamentos",
            "path": "/categories/1/drugs/metronidazol"
        },
        {
            "name": "Amoxicilina + Clavulanato de Potássio",
            "category": "Medicamentos",
            "path": "/categories/1/drugs/amoxicilina+clavulanatodepotassio"
        },
        {
            "name": "Prednisona/Prednisolona",
            "category": "Medicamentos",
            "path": "/categories/1/drugs/prednisonaprednisolona"
        },
        {
            "name": "Meloxicam",
            "category": "Medicamentos",
            "path": "/categories/1/drugs/meloxicam"
        },
        {
            "name": "Acetilcisteína",
            "category": "Medicamentos",
            "path": "/categories/1/drugs/acetilcisteina"
        },
        {
            "name": "Dipirona",
            "category": "Medicamentos",
            "path": "/categories/1/drugs/dipirona"
        },
        {
            "name": "Metadona",
            "category": "Medicamentos",
            "path": "/categories/1/drugs/metadona"
        },
        {
            "name": "Agemoxi CL",
            "category": "Medicamentos",
            "description": "1",
            "path": "/categories/1/products/agemoxicl"
        }, {
            "name": "Cerenia Injetável ",
            "category": "Medicamentos",
            "description": "1",
            "path": "/categories/1/products/cereniainjetavel"
        }, {
            "name": "Acepran ",
            "category": "Medicamentos",
            "description": "1",
            "path": "/categories/1/products/acepran"
        }, {
            "name": "Prediderm",
            "category": "Medicamentos",
            "description": "1",
            "path": "/categories/1/products/prediderm"
        }, {
            "name": "Giardicid Comprimido ",
            "category": "Medicamentos",
            "description": "1",
            "path": "/categories/1/products/giardicidcomprimido"
        }, {
            "name": "Vonau Vet",
            "category": "Medicamentos",
            "description": "1",
            "path": "/categories/1/products/vonauvet"
        }, {
            "name": "Gaviz V",
            "category": "Medicamentos",
            "description": "1",
            "path": "/categories/1/products/gavizv"
        }, {
            "name": "Imizol",
            "category": "Medicamentos",
            "description": "1",
            "path": "/categories/1/products/imizol"
        }, {
            "name": "Cronidor Comprimido ",
            "category": "Medicamentos",
            "description": "1",
            "path": "/categories/1/products/cronidorcomprimido"
        },
        {
            "name": "Emedron",
            "category": "Medicamentos",
            "description": "1",
            "path": "/categories/1/products/emedron"
        },
        {
            "name": "ADEFarm Oral ",
            "category": "Suplementos",
            "description": "1",
            "path": "/categories/6/products/adefarmoral"
        },
        {
            "name": "Diclofenaco Sódico - Oftalmológico ",
            "category": "Agentes Oftalmológicos",
            "description": null,
            "path": "/categories/5/drugs/diclofenacosodicooftalmologico"
        },
        {
            "name": "Tobramicina - Oftalmológico ",
            "category": "Agentes Oftalmológicos",
            "description": null,
            "path": "/categories/5/drugs/tobramicinaoftalmologico"
        },
        {
            "name": "Acetato de Prednisolona - Oftalmológico ",
            "category": "Agentes Oftalmológicos",
            "description": null,
            "path": "/categories/5/drugs/acetatodeprednisolonaoftalmologico"
        },
        {
            "name": "BronchiGuard",
            "category": "Vacinas e Biológicos",
            "description": "1",
            "path": "/categories/2/products/bronchiguard"
        },
        {
            "name": "Ciprovet Colírio ",
            "category": "Agentes Oftalmológicos",
            "description": "1",
            "path": "/categories/5/products/ciprovetcolirio"
        },
        {
            "name": "Bioraiva Pet ",
            "category": "Vacinas e Biológicos",
            "description": "1",
            "path": "/categories/2/products/bioraivapet"
        },
        {
            "name": "Balance | Adultos | Carne e Vegetais (Gatos)",
            "category": "Alimentos Completos",
            "description": "1",
            "path": "/categories/9/products/balance|adultos|carneevegetais(gatos)"
        },
        {
            "name": "Clorexidina - Tópico ",
            "category": "Dermatológicos Tópicos",
            "description": null,
            "path": "/categories/4/drugs/clorexidinatopico"
        },
        {
            "name": "Leish-Tec",
            "category": "Vacinas e Biológicos",
            "description": "1",
            "path": "/categories/2/products/leishtec"
        },
        {
            "name": "Calculadora de Dose",
            "category": "Calculadoras",
            "description": null,
            "path": "/calculators/dose/custom"
        },
        {
            "name": "Infusão Contínua",
            "category": "Calculadoras",
            "description": null,
            "path": "/calculators/continuous-infusion/custom"
        },
        {
            "name": "Calculadora de Regra de Três",
            "category": "Calculadoras",
            "description": null,
            "path": "/calculators/rule-of-three/custom"
        },
        {
            "name": "Transfusão | Volume de Sangue + Velocidade de Administração",
            "category": "Calculadoras",
            "description": null,
            "path": "/calculators/transfusion-volume-speed/custom"
        },
        {
            "name": "Calculadora de Conversão de Pesos",
            "category": "Calculadoras",
            "description": null,
            "path": "/calculators/813d534663204911a17fd39f08d49fbe"
        },
        {
            "name": "Conversão de Concentrações",
            "category": "Calculadoras",
            "description": null,
            "path": "/calculators/41d8c9ff6f91483f869e895108167b97"
        },
        {
            "name": "Cálculo de Superfície Corporal",
            "category": "Calculadoras",
            "description": null,
            "path": "/calculators/0d28048c89e943d7ae9ecdfb009014a3"
        },
        {
            "name": "Transfusão | Volume de Sangue",
            "category": "Calculadoras",
            "description": null,
            "path": "/calculators/e6cd7d1688fc48df97d2d6eebf0b2526"
        },
        {
            "name": "Calculadora de Calorias e Peso Ideal",
            "category": "Calculadoras",
            "description": null,
            "path": "/calculators/e0352fcfe56742558ffe2d493d6075ec"
        },
        {
            "name": "Calculadora de Conversão de Volume",
            "category": "Calculadoras",
            "description": null,
            "path": "/calculators/734b21eb3f964e0b83180645573e421a"
        }
    ],
}